module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_c('em', [_vm._v("Contents")])])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    attrs: {
      "href": "#/006_Preface#fm-1"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PREFACE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/007_Consulting_Editors#fm-2"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CONSULTING")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EDITORS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Contributors#fm-3"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CONTRIBUTORS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Alphabetical_List#fm-4"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ALPHABETICAL")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LIST OF")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ENTRIES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Topical_List#fm-5"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TOPICAL")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LIST OF")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ENTRIES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Map_List#fm-6"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LIST OF")]), _vm._v(" "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MAPS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chronology#fm-7"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHRONOLOGY")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/013_Abbreviations#fm-8"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ABBREVIATIONS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-parta"
  }, [_c('strong', [_vm._v("ESSAYS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/014_Chapter01#ch-1"
    }
  }, [_vm._v("Early Judaism in Modern Scholarship")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('a', {
    attrs: {
      "href": "#/014_Chapter01#ch-1"
    }
  }, [_c('em', [_vm._v("John J. Collins")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/015_Chapter02#ch-2"
    }
  }, [_vm._v("Jewish History from Alexander to Hadrian")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('a', {
    attrs: {
      "href": "#/015_Chapter02#ch-2"
    }
  }, [_c('em', [_vm._v("Chris Seeman and Adam Kolman Marshak")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/016_Chapter03#ch-3"
    }
  }, [_vm._v("Judaism in the Land of Israel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('a', {
    attrs: {
      "href": "#/016_Chapter03#ch-3"
    }
  }, [_c('em', [_vm._v("James C. VanderKam")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/017_Chapter04#ch-4"
    }
  }, [_vm._v("Judaism in the Diaspora")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('a', {
    attrs: {
      "href": "#/017_Chapter04#ch-4"
    }
  }, [_c('em', [_vm._v("Erich S. Gruen")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/018_Chapter05#ch-5"
    }
  }, [_vm._v("The Jewish Scriptures: Texts, Versions, Canons")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('a', {
    attrs: {
      "href": "#/018_Chapter05#ch-5"
    }
  }, [_c('em', [_vm._v("Eugene Ulrich")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/019_Chapter06#ch-6"
    }
  }, [_vm._v("Early Jewish Biblical Interpretation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('a', {
    attrs: {
      "href": "#/019_Chapter06#ch-6"
    }
  }, [_c('em', [_vm._v("James L. Kugel")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/020_Chapter07#ch-7"
    }
  }, [_vm._v("Apocrypha and Pseudepigrapha")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('a', {
    attrs: {
      "href": "#/020_Chapter07#ch-7"
    }
  }, [_c('em', [_vm._v("Loren T. Stuckenbruck")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/021_Chapter08#ch-8"
    }
  }, [_vm._v("Dead Sea Scrolls")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('a', {
    attrs: {
      "href": "#/021_Chapter08#ch-8"
    }
  }, [_c('em', [_vm._v("Eibert Tigchelaar")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/022_Chapter09#ch-9"
    }
  }, [_vm._v("Early Jewish Literature Written in Greek")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('a', {
    attrs: {
      "href": "#/022_Chapter09#ch-9"
    }
  }, [_c('em', [_vm._v("Katell Berthelot")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter10#ch-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Archaeology, Papyri, and Inscriptions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter10#ch-10",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Jürgen K. Zangenberg")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/024_Chapter11#ch-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jews among Greeks and Romans")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/024_Chapter11#ch-11",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Miriam Pucci Ben Zeev")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/025_Chapter12#ch-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Early Judaism and Early Christianity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/025_Chapter12#ch-12",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Daniel C. Harlow")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/026_Chapter13#ch-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Early Judaism and Rabbinic Judaism")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/026_Chapter13#ch-13",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Lawrence H. Schiffman")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-parta"
  }, [_c('span', {
    attrs: {
      "href": "#/027_BM01#bm-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("DICTIONARY ENTRIES A-Z")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60dfd2d9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/005_Contents.vue
// module id = 69
// module chunks = 0